import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LegacyRedirectGuard {
  constructor(private readonly router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean> {
    return this.helper(route);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Promise<boolean> {
    return this.helper(childRoute);
  }

  private async helper(route: ActivatedRouteSnapshot): Promise<boolean> {
    /*
     * Old urls were in the format /?hostId=uid-123&meetingTypeId=30-minutes
     * New urls are formatted as /book/uid-123/30-minutes
     */
    const { hostId, meetingTypeId } = route.queryParams;
    const meetingId = route.params.meetingId;

    const queryParams = { ...route.queryParams };
    if (meetingId && hostId) {
      delete queryParams.hostId;
      if (route.toString().indexOf('reschedules/') >= 0) {
        await this.router.navigate([`/reschedules/${hostId}/${meetingId}`], {
          queryParams,
        });
      } else if (route.toString().indexOf('cancels/') >= 0) {
        await this.router.navigate([`/cancels/${hostId}/${meetingId}`], {
          queryParams,
        });
      }
    } else if (hostId) {
      delete queryParams.hostId;
      delete queryParams.meetingTypeId;
      await this.router.navigate(
        [`/book/${hostId}/${meetingTypeId || '30-minutes'}`],
        { queryParams }
      );
    }

    return true;
  }
}
